import { render, staticRenderFns } from "./VircosGraphics.vue?vue&type=template&id=78af5032&scoped=true&"
import script from "./VircosGraphics.vue?vue&type=script&lang=js&"
export * from "./VircosGraphics.vue?vue&type=script&lang=js&"
import style0 from "./VircosGraphics.vue?vue&type=style&index=0&id=78af5032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78af5032",
  null
  
)

export default component.exports